import { validateAction } from "../../../questionnaire/utils/validateAction";
import type { QuestionnaireState } from "../../types";
import { getVisibleSection } from "../../../questionnaire/utils/getVisibleSection";

export const handleValidateFormAction = (
  state: QuestionnaireState,
): QuestionnaireState => {
  const { errors, firstInvalidSectionIndex } = validateAction(state);
  const { currentSectionIndex } = state;
  const errorCount = Object.keys(errors).length;
  const isValid = errorCount === 0;

  //Move to the first invalid section if one is invalid and it's prior to or equal to the current section
  //Otherwise, move to the next visible section
  const updatedSectionIndex = Math.min(
    firstInvalidSectionIndex ?? currentSectionIndex,
    getVisibleSection(state, "next"),
  );

  return {
    ...state,
    errors,
    isValid,
    currentSectionIndex: updatedSectionIndex,
  };
};
